import React from "react";
import * as CHQ from "chq";

import { DefaultProfile } from "app/context/ProfileContext";
import AutoRecognizedNotification from "./AutoRecognizedNotification";
import CommentCheeredNotification from "./CommentCheeredNotification";
import CommentRepliedNotification from "./CommentRepliedNotification";
import ConnectionCreatedNotification from "./ConnectionCreatedNotification";
import EventCancelledNotification from "./EventCancelledNotification";
import EventCommentedNotification from "./EventCommentedNotification";
import EventConfirmedNotification from "./EventConfirmedNotification";
import EventDeletedNotification from "./EventDeletedNotification";
import EventHostingCappedNotification from "./EventHostingCappedNotification";
import EventHostingEndedNotification from "./EventHostingEndedNotification";
import EventHostingRsvpdNotification from "./EventHostingRsvpdNotification";
import EventInterestsAlignedNotification from "./EventInterestsAlignedNotification";
import EventInviteNotification from "./EventInviteNotification";
import EventNotificationNotification from "./EventNotificationNotification";
import FeedbackReviewedNotification from "./FeedbackReviewedNotification";
import FeedbackSubmittedNotification from "./FeedbackSubmittedNotification";
import FlagCreatedNotification from "./FlagCreatedNotification";
import InterestsAlignedNotification from "./InterestsAlignedNotification";
import MentionedNotification from "./MentionedNotification";
import PhotoCheeredNotification from "./PhotoCheeredNotification";
import PhotoCommentedNotification from "./PhotoCommentedNotification";
import PhotoTaggedNotification from "./PhotoTaggedNotification";
import PointIncrementNotification from "./PointIncrementNotification";
import PostCommentedNotification from "./PostCommentedNotification";
import RecognitionApprovedNotification from "./RecognitionApprovedNotification";
import RecognitionGivenCheeredNotification from "./RecognitionGivenCheeredNotification";
import RecognitionGivenCommentedNotification from "./RecognitionGivenCommentedNotification";
import RecognitionPendingNotification from "./RecognitionPendingNotification";
import RecognitionReceivedCheeredNotification from "./RecognitionReceivedCheeredNotification";
import RecognitionReceivedCommentedNotification from "./RecognitionReceivedCommentedNotification";
import RecognizedNotification from "./RecognizedNotification";
import StoryCheeredNotification from "./StoryCheeredNotification";
import StoryCommentedNotification from "./StoryCommentedNotification";
import StoryAnsweredNotification from "./StoryAnsweredNotification";
import CommentOfInterestNotification from "./CommentOfInterestNotification";
import UserActivityCheeredNotification from "./UserActivityCheeredNotification";
import UserClaimedCommentedNotification from "./UserClaimedCommentedNotification";
import SurveyCommentedNotification from "./SurveyCommentedNotification";
import AnnouncementCommentedNotification from "./AnnouncementCommentedNotification";
import StoryTrendCommentedNotification from "./StoryTrendCommentedNotification";
import MentionedGroupNotification from "./MentionedGroupNotification";
import StoryAnswerNotification from "./StoryAnswerNotification";
import StorySharedNotification from "./StorySharedNotification";
import VideoStoryUpdatedNotification from "./VideoStoryUpdatedNotification";
import VideoStoryCreatedNotification from "./VideoStoryCreatedNotification";
import ProcessingVideoStoryNotification from "./ProcessingVideoStoryNotification";
import ProcessingLinkedinPostNotification from "./ProcessingLinkedinPostNotification";
import LinkedinPostCreatedNotification from "./LinkedinPostCreatedNotification";
import LinkedinPostErrorNotification from "./LinkedinPostErrorNotification";
import LinkedinPostSharedNotification from "./LinkedinPostSharedNotification";
import VideoMontageErrorNotification from "./VideoMontageErrorNotification";
import ProcessingVideoMontageNotification from "./ProcessingVideoMontageNotification";
import VideoMontageCreationErrorNotification from "./VideoMontageCreationErrorNotification";
import VideoMontageDoneNotification from "./VideoMontageDoneNotification";
import ProcessingVideoStoryQuestionNotification from "./ProcessingVideoStoryQuestionNotification";
import VideoStoryQuestionCreatedNotification from "./VideoStoryQuestionCreatedNotification";
import VideoStoryQuestionUpdatedNotification from "./VideoStoryQuestionUpdatedNotification";
import ShareStoryNotification from "./ShareStoryNotification";
import EngageStoryNotification from "./EngageStoryNotification";
import ProcessingTiktokPostNotification from "./ProcessingTiktokPostNotification";
import TiktokPostCreatedNotification from "./TiktokPostCreatedNotification";
import TiktokPostErrorNotification from "./TiktokPostErrorNotification";
import ProcessingFacebookPostNotification from "./ProcessingFacebookPostNotification";
import FacebookPostCreatedNotification from "./FacebookPostCreatedNotification";
import FacebookPostErrorNotification from "./FacebookPostErrorNotification";
import ProcessingInstagramPostNotification from "./ProcessingInstagramPostNotification";
import InstagramPostCreatedNotification from "./InstagramPostCreatedNotification";
import InstagramPostErrorNotification from "./InstagramPostErrorNotification";
import StoryReviewerNotification from "./StoryReviewerNotification";
import SuccessScheduledyNotification from "./SuccessScheduledyNotification";
import FacebookInstagramPersonalReminderNotification from "./FacebookInstagramPersonalReminderNotification";
import SocialSharePersonalReminderNotification from "./SocialSharePersonalReminderNotification";
import ProcessingStoryErrorNotification from "./ProcessingStoryErrorNotification";
import ProcessingImageDoneNotification from "./ProcessingImageDoneNotification";
import PublicVideoStoryCreatedNotification from "./PublicVideoStoryCreatedNotification";
import DownloadingVideoStoryNotification from "./DownloadingVideoStoryNotification";
import DownloadingImageStoryNotification from "./DownloadingImageStoryNotification";
import DownloadingVideoMontageNotification from "./DownloadingVideoMontageNotification";
import ProcessingNeededApprovalVideoStoryNotification from "./ProcessingNeededApprovalVideoStoryNotification";
import NeededApprovalVideoStoryCreatedUpdatedNotification from "./NeededApprovalVideoStoryCreatedUpdatedNotification";
import TemplateDoneNotification from "./TemplateDoneNotification";
import ProcessingTemplateNotification from "./ProcessingTemplateNotification";
import ActivatingTemplateNotification from "./ActivatingTemplateNotification";

const notificationFor = (
  notification: CHQ.Notification,
  tabIndex = 0,
  dismiss = undefined,
  profile: CHQ.Profile | DefaultProfile | undefined = undefined
) => {
  switch (notification.notificationType) {
    case "auto_recognized":
      return (
        <AutoRecognizedNotification
          notification={notification as CHQ.NotificationAutoRecognized}
        />
      );
    case "comment_cheered":
      return (
        <CommentCheeredNotification
          notification={notification as CHQ.NotificationCommentCheered}
          tabIndex={tabIndex}
        />
      );
    case "user_activity_cheered":
      return (
        <UserActivityCheeredNotification
          notification={notification as CHQ.NotificationUserActivityCheered}
          tabIndex={tabIndex}
        />
      );
    case "comment_replied":
      return (
        <CommentRepliedNotification
          notification={notification as CHQ.NotificationCommentReplied}
          tabIndex={tabIndex}
        />
      );
    case "connection_created":
      return (
        <ConnectionCreatedNotification
          notification={notification as CHQ.NotificationConnectionCreated}
          tabIndex={tabIndex}
        />
      );
    case "event_cancelled":
      return (
        <EventCancelledNotification
          notification={notification as CHQ.NotificationEventCancelled}
          tabIndex={tabIndex}
        />
      );
    case "event_commented":
      return (
        <EventCommentedNotification
          notification={notification as CHQ.NotificationEventCommented}
          tabIndex={tabIndex}
        />
      );
    case "event_confirmed":
      return (
        <EventConfirmedNotification
          notification={notification as CHQ.NotificationEventConfirmed}
        />
      );
    case "event_deleted":
      return (
        <EventDeletedNotification
          notification={notification as CHQ.NotificationEventDeleted}
          tabIndex={tabIndex}
        />
      );
    case "event_hosting_capped":
      return (
        <EventHostingCappedNotification
          notification={notification as CHQ.NotificationEventHostingCapped}
          tabIndex={tabIndex}
        />
      );
    case "event_hosting_ended":
      return (
        <EventHostingEndedNotification
          notification={notification as CHQ.NotificationEventHostingEnded}
          tabIndex={tabIndex}
        />
      );
    case "event_hosting_rsvpd":
      return (
        <EventHostingRsvpdNotification
          notification={notification as CHQ.NotificationEventHostingRsvpd}
          tabIndex={tabIndex}
        />
      );
    case "event_interests_aligned":
      return (
        <EventInterestsAlignedNotification
          notification={notification as CHQ.NotificationEventInterestsAligned}
          tabIndex={tabIndex}
        />
      );
    case "event_invite":
      return (
        <EventInviteNotification
          notification={notification as CHQ.NotificationEventInvite}
          tabIndex={tabIndex}
        />
      );
    case "event_notification":
      return (
        <EventNotificationNotification
          notification={notification as CHQ.NotificationEventNotification}
          tabIndex={tabIndex}
        />
      );
    case "feedback_reviewed":
      return <FeedbackReviewedNotification />;
    case "feedback_submitted":
      return (
        <FeedbackSubmittedNotification
          notification={notification as CHQ.NotificationFeedbackSubmitted}
          tabIndex={tabIndex}
        />
      );
    case "flag_created":
      return (
        <FlagCreatedNotification
          notification={notification as CHQ.NotificationFlagCreated}
          tabIndex={tabIndex}
        />
      );
    case "interests_aligned":
      return (
        <InterestsAlignedNotification
          notification={notification as CHQ.NotificationInterestsAligned}
          tabIndex={tabIndex}
        />
      );
    case "mentioned":
      return (
        <MentionedNotification
          notification={notification as CHQ.NotificationMentioned}
          tabIndex={tabIndex}
        />
      );
    case "mentioned_in_group":
      return (
        <MentionedGroupNotification
          notification={notification as CHQ.NotificationMentionedGroup}
          tabIndex={tabIndex}
        />
      );
    case "photo_cheered":
      return (
        <PhotoCheeredNotification
          notification={notification as CHQ.NotificationPhotoCheered}
          tabIndex={tabIndex}
        />
      );
    case "photo_commented":
      return (
        <PhotoCommentedNotification
          notification={notification as CHQ.NotificationPhotoCommented}
          tabIndex={tabIndex}
        />
      );
    case "photo_tagged":
      return (
        <PhotoTaggedNotification
          notification={notification as CHQ.NotificationPhotoTagged}
          tabIndex={tabIndex}
        />
      );
    case "points_incremented":
      return (
        <PointIncrementNotification
          notification={notification as CHQ.NotificationPointIncrement}
        />
      );
    case "post_commented":
      return (
        <PostCommentedNotification
          notification={notification as CHQ.NotificationPostCommented}
          tabIndex={tabIndex}
        />
      );
    case "recognition_approved":
      return (
        <RecognitionApprovedNotification
          notification={notification as CHQ.NotificationRecognitionApproved}
          tabIndex={tabIndex}
        />
      );
    case "recognition_given_cheered":
      return (
        <RecognitionGivenCheeredNotification
          notification={notification as CHQ.NotificationRecognitionGivenCheered}
          tabIndex={tabIndex}
        />
      );
    case "recognition_given_commented":
      return (
        <RecognitionGivenCommentedNotification
          notification={
            notification as CHQ.NotificationRecognitionGivenCommented
          }
          tabIndex={tabIndex}
        />
      );
    case "recognition_pending":
      return (
        <RecognitionPendingNotification
          notification={notification as CHQ.NotificationRecognitionPending}
          tabIndex={tabIndex}
        />
      );
    case "recognition_received_cheered":
      return (
        <RecognitionReceivedCheeredNotification
          notification={
            notification as CHQ.NotificationRecognitionReceivedCheered
          }
          tabIndex={tabIndex}
        />
      );
    case "recognition_received_commented":
      return (
        <RecognitionReceivedCommentedNotification
          notification={
            notification as CHQ.NotificationRecognitionReceivedCommented
          }
          tabIndex={tabIndex}
        />
      );
    case "recognized":
      return (
        <RecognizedNotification
          notification={notification as CHQ.NotificationRecognized}
          tabIndex={tabIndex}
        />
      );
    case "story_cheered":
      return (
        <StoryCheeredNotification
          notification={notification as CHQ.NotificationStoryCheered}
          tabIndex={tabIndex}
        />
      );
    case "story_commented":
      return (
        <StoryCommentedNotification
          notification={notification as CHQ.NotificationStoryCommented}
          tabIndex={tabIndex}
        />
      );
    case "story_trend_commented":
      return (
        <StoryTrendCommentedNotification
          notification={notification as CHQ.NotificationStoryCommented}
          tabIndex={tabIndex}
        />
      );
    case "answered_story":
      return (
        <StoryAnsweredNotification
          notification={notification as CHQ.NotificationStoryAnswered}
          tabIndex={tabIndex}
        />
      );
    case "story_reviewer":
      return (
        <StoryReviewerNotification
          notification={notification as CHQ.NotificationStoryReviewed}
          tabIndex={tabIndex}
        />
      );
    case "answer_story":
      return (
        <StoryAnswerNotification
          notification={notification as CHQ.NotificationStoryAnswer}
          tabIndex={tabIndex}
        />
      );
    case "story_question_shared":
      return (
        <StorySharedNotification
          notification={notification as CHQ.NotificationStoryShared}
          tabIndex={tabIndex}
        />
      );
    case "comment_of_interest":
      return (
        <CommentOfInterestNotification
          notification={notification as CHQ.NotificationCommentOfInterest}
          tabIndex={tabIndex}
        />
      );
    case "user_claimed_commented":
      return (
        <UserClaimedCommentedNotification
          notification={notification as CHQ.NotificationUserClaimedCommented}
          tabIndex={tabIndex}
        />
      );
    case "survey_commented":
      return (
        <SurveyCommentedNotification
          notification={notification as CHQ.NotificationSurveyCommented}
          tabIndex={tabIndex}
        />
      );
    case "announcement_commented":
      return (
        <AnnouncementCommentedNotification
          notification={notification as CHQ.NotificationAnnouncementCommented}
          tabIndex={tabIndex}
        />
      );
    case "video_story_updated":
      return (
        <VideoStoryUpdatedNotification
          notification={notification as CHQ.NotificationVideoStoryUpdated}
          tabIndex={tabIndex}
        />
      );
    case "video_story_created":
      return (
        <VideoStoryCreatedNotification
          notification={notification as CHQ.NotificationVideoStoryCreated}
          tabIndex={tabIndex}
          dismiss={dismiss}
        />
      );
    case "needed_approval_video_story_created":
    case "needed_approval_video_story_updated":
    case "needed_approval_video_montage_done":
      return (
        <NeededApprovalVideoStoryCreatedUpdatedNotification
          notification={notification as CHQ.NeededApprovalNotificationVideoStoryCreated}
        />
      );
    case "public_video_story_created":
      return (
        <PublicVideoStoryCreatedNotification
          notification={notification as CHQ.NotificationVideoStoryCreated}
        />
      );
    case "processing_image_story":
    case "processing_video_story":
      return (
        <ProcessingVideoStoryNotification
          notification={notification as CHQ.NotificationProcessingVideoStory}
          tabIndex={tabIndex}
        />
      );
    case "processing_needed_approval_image_story":
    case "processing_needed_approval_video_story":
      return (
        <ProcessingNeededApprovalVideoStoryNotification
          notification={notification as CHQ.NotificationProcessingNeededApprovalVideoStory}
        />
      );
    case "linkedin_post_created":
      return (
        <LinkedinPostCreatedNotification
          notification={notification as CHQ.NotificationLinkedinPostCreated}
          tabIndex={tabIndex}
        />
      );
    case "linkedin_post_error":
      return (
        <LinkedinPostErrorNotification
          notification={notification as CHQ.NotificationLinkedinPostError}
          tabIndex={tabIndex}
        />
      );
    case "linkedin_post_shared":
      return (
        <LinkedinPostSharedNotification
          notification={notification as CHQ.NotificationLinkedinPostShared}
          tabIndex={tabIndex}
        />
      );
    case "processing_linkedin_post":
      return (
        <ProcessingLinkedinPostNotification
          notification={notification as CHQ.NotificationProcessingLinkedinPost}
          tabIndex={tabIndex}
        />
      );
    case "processing_story_error":
      return (
        <ProcessingStoryErrorNotification
          notification={notification as CHQ.NotificationProcessingStoryError}
          tabIndex={tabIndex}
        />
      );
    case "video_montage_error":
      return (
        <VideoMontageErrorNotification
          notification={notification as CHQ.NotificationVideoMontageError}
          tabIndex={tabIndex}
        />
      );
    case "video_montage_done":
      return (
        <VideoMontageDoneNotification
          notification={notification as CHQ.NotificationVideoMontageDone}
          tabIndex={tabIndex}
        />
      );
    case "processing_image_done":
    case "processing_image_creation_done":
      return (
        <ProcessingImageDoneNotification
          notification={notification as CHQ.NotificationProcessingImageDone}
          tabIndex={tabIndex}
        />
      );
    case "processing_video_montage":
      return (
        <ProcessingVideoMontageNotification
          notification={notification as CHQ.NotificationProcessingVideoMontage}
          tabIndex={tabIndex}
        />
      );
    case "video_montage_creation_error":
      return (
        <VideoMontageCreationErrorNotification
          notification={notification as CHQ.NotificationVideoMontageCreationError}
          tabIndex={tabIndex}
        />
      );
    case "video_story_question_created":
      return (
        <VideoStoryQuestionCreatedNotification
          notification={notification as CHQ.NotificationVideoStoryQuestionCreated}
          tabIndex={tabIndex}
        />
      );
    case "video_story_question_updated":
      return (
        <VideoStoryQuestionUpdatedNotification
          notification={notification as CHQ.NotificationVideoStoryQuestionUpdated}
          tabIndex={tabIndex}
        />
      );
    case "processing_video_story_question":
      return (
        <ProcessingVideoStoryQuestionNotification
          notification={notification as CHQ.NotificationProcessingVideoStoryQuestion}
          tabIndex={tabIndex}
        />
      );
    case "share_story":
      return (
        <ShareStoryNotification
          notification={notification as CHQ.NotificationShareStory}
          tabIndex={tabIndex}
        />
      );
    case "success_scheduled":
      return (
        <SuccessScheduledyNotification
          notification={notification as CHQ.NotificationSuccessScheduledShare}
          tabIndex={tabIndex}
        />
      );
    case "engage_story":
      return (
        <EngageStoryNotification
          notification={notification as CHQ.NotificationEngageStory}
          tabIndex={tabIndex}
        />
      );
    case "processing_tiktok_post":
      return (
        <ProcessingTiktokPostNotification
          notification={notification as CHQ.NotificationProcessingTiktokPost}
          tabIndex={tabIndex}
        />
      );
    case "tiktok_post_created":
      return (
        <TiktokPostCreatedNotification
          notification={notification as CHQ.NotificationTiktokPostCreated}
          tabIndex={tabIndex}
        />
      );
    case "tiktok_post_error":
      return (
        <TiktokPostErrorNotification
          notification={notification as CHQ.NotificationTiktokPostError}
          tabIndex={tabIndex}
        />
      );
    case "processing_facebook_post":
      return (
        <ProcessingFacebookPostNotification
          notification={notification as CHQ.NotificationProcessingFacebookPost}
          tabIndex={tabIndex}
        />
      );
    case "facebook_post_created":
      return (
        <FacebookPostCreatedNotification
          notification={notification as CHQ.NotificationFacebookPostCreated}
          tabIndex={tabIndex}
        />
      );
    case "facebook_post_error":
      return (
        <FacebookPostErrorNotification
          notification={notification as CHQ.NotificationFacebookPostError}
          tabIndex={tabIndex}
        />
      );
    case "processing_instagram_post":
      return (
        <ProcessingInstagramPostNotification
          notification={notification as CHQ.NotificationProcessingInstagramPost}
          tabIndex={tabIndex}
        />
      );
    case "instagram_post_created":
      return (
        <InstagramPostCreatedNotification
          notification={notification as CHQ.NotificationInstagramPostCreated}
          tabIndex={tabIndex}
        />
      );
    case "instagram_post_error":
      return (
        <InstagramPostErrorNotification
          notification={notification as CHQ.NotificationInstagramPostError}
          tabIndex={tabIndex}
        />
      );
    case "facebook_instagram_personal_reminder":
      return (
        <FacebookInstagramPersonalReminderNotification
          notification={notification as CHQ.NotificationFacebookInstagramPersonalReminder}
          tabIndex={tabIndex}
        />
      );
    case "social_personal_reminder":
      return (
        <SocialSharePersonalReminderNotification
          notification={notification as CHQ.NotificationSocialPersonalReminder}
          tabIndex={tabIndex}
        />
      );
    case "downloading_montage":
      return (
        <DownloadingVideoMontageNotification
          notification={notification as CHQ.NotificationDownloadingMontage}
        />
      );
    case "downloading_video_story":
      return (
        <DownloadingVideoStoryNotification
          notification={notification as CHQ.NotificationDownloadingVideoStory}
        />
      );
    case "downloading_image_story":
      return (
        <DownloadingImageStoryNotification
          notification={notification as CHQ.NotificationDownloadingImageStory}
        />
      );
    case "template_being_processed":
      return (
        <ProcessingTemplateNotification
          notification={notification as CHQ.NotificationProcessingTemplate}
          profile={profile}
        />
      );
    case "template_being_activated":
      return (
        <ActivatingTemplateNotification
          notification={notification as CHQ.NotificationProcessingTemplate}
          profile={profile}
        />
      );
    case "template_is_done":
      return (
        <TemplateDoneNotification
          notification={notification as CHQ.NotificationTemplateDone}
          profile={profile}
        />
      );
    default:
      return null;
  }
};

export default notificationFor;
